const SKU_MAX_LENGTH = 30;

/**
 * A starting code for a product made on the fly: the title in capital ASCII
 * letters and digits, words joined by "-". Lithuanian letters lose their marks
 * (ą→A, š→S, ž→Z …) because codes travel to accounting systems that expect ASCII.
 */
export function suggestSku(title: string): string {
  return title
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "-")
    .replace(/^-+/, "")
    .slice(0, SKU_MAX_LENGTH)
    .replace(/-+$/, "");
}
